import { FlexibleBaseSpecification, FlexibleModelBase } from './flexible_base';

export interface FlexibleListDirectionalSpecification extends FlexibleBaseSpecification {
	id: number;
	items: FlexibleModelBase[];
	direction: string;
	title: string;
}

export class FlexibleListDirectionalModel extends FlexibleModelBase {
	public readonly items: FlexibleModelBase[];
	public readonly title: string;
	public readonly direction: string;

	constructor(spec: FlexibleListDirectionalSpecification) {
		super(spec);
		this.title = spec.title;
		this.items = spec.items;
		this.direction = spec.direction;
	}
}
